export default __webpack_public_path__ + "static/media/iconSearchWhite.95898479.svg";